import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Field }                                            from 'redux-form';
import RadioField                                           from '../fields/redux/base/RadioField';
import { useTranslation }                                   from 'react-i18next';
import SingleSelect                                         from '../fields/select/SingleSelect';
import Calendar                                             from '../Calendar';

const RadioFieldWrapper = ({
  input,
  meta: {
          touched,
          error,
        },
  options,
}) => {
  const {
          t,
          i18n: { language },
        }                                   = useTranslation();
  const [dayState, setDayState]             = useState(t('label_today'));
  const [timeState, setTimeState]           = useState(t('client_call_for_five_minutes'));
  const [isDisabled, setIsDisabled]         = useState(true);
  const [selectedOption, setSelectedOption] = useState(options[0].value);
  const [combinedValue, setCombinedValue]   = useState({
    day:  t('label_today'),
    time: t('client_call_for_five_minutes'),
  });

  useEffect(() => {
    setCombinedValue({
      day:  dayState,
      time: timeState,
    });
  }, [dayState, timeState]);

  const dayOptions = useMemo(() => [
    {
      label: t('label_today'),
      value: t('label_today'),
    },
    {
      label: t('label_tomorrow'),
      value: t('label_tomorrow'),
    },
    {
      label: t('label_calendar'),
      value: t('label_calendar'),
    },
  ], [language]);

  const generateTimeIntervals = useCallback(() => {
    const intervals = [];
    const startTime = new Date('1970-01-01T08:30:00');
    const endTime   = new Date('1970-01-01T17:00:00');

    const formatTime = (date) => date.toLocaleTimeString([], {
      hour:   '2-digit',
      minute: '2-digit',
    });

    for (let time = startTime; time < endTime; time.setMinutes(time.getMinutes() + 30)) {
      const start = formatTime(time);
      const end   = formatTime(new Date(time.getTime() + 30 * 60000));
      intervals.push({
        label: `${start} - ${end}`,
        value: `${start} - ${end}`,
      });
    }

    return intervals;
  }, []);

  const handleChangeDay = useCallback((day) => {
    setDayState(day || t('label_today'));
  }, [language]);

  const handleChangeTime = useCallback((time) => {
    setTimeState(time || generateTimeIntervals()[0].value);
  }, [generateTimeIntervals]);

  const handleOptionChange = useCallback((optionValue) => {
    setSelectedOption(optionValue);
    input.onChange(combinedValue);
  }, [combinedValue, input]);

  useEffect(() => {
    input.onChange(combinedValue);
  }, [combinedValue, input]);

  return (
    <>
      <div className={'radio-group'}>
        {options.map((option) => (
          <div
            className={'radio-wrapper'}
            key={option.value}
            onClick={() => {
              setIsDisabled(option.label !== t('client_call_for_other_time'));
              handleOptionChange(option.value);
              if (option.value === '5') {
                setDayState(t('label_today'));
                setTimeState(generateTimeIntervals()[0].value);
                setCombinedValue({
                  day:  dayState,
                  time: option.label,
                });
              } else {
                if (option.label === t('client_call_for_other_time')) {
                  return;
                }
                setDayState(t('label_today'));
                setTimeState(generateTimeIntervals()[0].value);
                setCombinedValue({
                  day:  dayState,
                  time: timeState,
                });
              }
            }}
          >
            <RadioField
              className={'radio'}
              id={`radio-${option.value}`}
              type={'radio'}
              value={
                option.label === t('client_call_for_other_time')
                  ? Object.values(combinedValue)
                    .join(' ')
                  : `${t('label_today')} ${t('client_call_for_five_minutes')
                    .toLowerCase()}`
              }
              name={input.name}
              checked={selectedOption === option.value}
              onChange={() => handleOptionChange(option.value)}
            />
            <label htmlFor={`radio-${option.value}`}>{option.label}</label>
          </div>
        ))}
      </div>
      <div className={'selectContainer'}>
        <SingleSelect
          name={'daySelect'}
          placeholder={dayState ? dayState : t('label_today')}
          onChangeCallback={handleChangeDay}
          options={dayOptions}
          required
          selected={dayState}
          valueKey={'value'}
          labelKey={'label'}
          containsImage={'calendarImg'}
          disabled={isDisabled}
        />
        <SingleSelect
          name={'timeSelect'}
          placeholder={generateTimeIntervals()[0].label}
          options={generateTimeIntervals()}
          onChangeCallback={handleChangeTime}
          required
          selected={timeState}
          labelKey={'label'}
          valueKey={'value'}
          containsImage={'clockImg'}
          disabled={isDisabled}
        />
        <Calendar
          isOpened={() => dayState === t('label_calendar')}
          getDate={(date) => setDayState(date)}
          resetSelect={() => setDayState(t('label_today'))}
        />
      </div>
    </>
  );
};

export const RenderTimeField = (props) => (<>
  <p className={'call-time'}>{props.label}</p>
  <Field component={RadioFieldWrapper} {...props} />
</>);
